import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  FormularyFacade,
  FormularyRequest,
  SearchMore,
  TypeAHeadFacade,
} from '@cigna/pdl-viewer/drug-search/data-access';
import { ModalComponent } from '@cigna/shared/angular/modal-ui';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'cigna-formulary-drug-search',
  templateUrl: './formulary-drug-search.component.html',
  styleUrls: ['./formulary-drug-search.component.scss'],
})
export class FormularyDrugSearchComponent implements OnInit {
  @ViewChild('drugSearchModal', { static: true })
  drugSearchModal: ModalComponent;
  @Input() groupNumber: string;
  @Input() benefitOptionCode: string;
  @Input() eligibilitySystemCode: string;
  @Input() classId: string;
  @Input() stateCode: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() indicator: boolean;
  @Input() consumerId: string;
  @Input() searchQuery: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  drugDataLoading: boolean;
  searchAlphabet: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  showSearchInfo: boolean;
  searchQueryString: string;
  currentPage: number;
  isTherapeuticCode = false;
  urlParams: Params;

  constructor(
    private activRoute: ActivatedRoute,
    private _formularyFacade: FormularyFacade,
    private _typeAHeadFacade: TypeAHeadFacade,
  ) {}
  drugsList$ = this._formularyFacade.formularyDrugList$;
  otherInfo$ = this._formularyFacade.otherInformations$;
  typeaHead$ = this._typeAHeadFacade.typeaHead$;

  close() {
    this.searchAlphabet = '';
    this.drugSearchModal.close();
  }

  open() {
    this.searchAlphabet = '';
    this.currentPage = 0;
    this.drugDataLoading = false;
    this.drugSearchModal.open();
  }

  ngOnInit() {
    this.urlParams = this.activRoute.snapshot.queryParams;
  }

  getDrugList(query: string | number, loadMore: boolean) {
    this.drugDataLoading = true;
    this.isTherapeuticCode = false;
    this.searchQueryString = loadMore ? this.searchQueryString : String(query);
    this.currentPage = !loadMore ? 0 : this.currentPage + 1;
    const formularyRequest: FormularyRequest = {
      groupNumber: this.groupNumber,
      benefitOptionCode: this.benefitOptionCode,
      eligibilitySystemCode: this.eligibilitySystemCode,
      classId: this.classId,
      searchQuery: String(this.searchQueryString),
      expand: 'details',
      offset: this.currentPage * 50,
      limit: 50,
    };
    this._formularyFacade.loadFormularyDrugList(
      formularyRequest,
      false,
      loadMore,
    );
  }

  callToTypeaHead(searchString: string) {
    const formularyRequest: FormularyRequest = {
      searchQuery: searchString,
    };
    this._typeAHeadFacade.loadTypeaHead(formularyRequest, false);
  }

  getTherapeuticDrugList(searchMore: SearchMore) {
    this.isTherapeuticCode = true;
    this.searchAlphabet = '';
    this.drugDataLoading = true;
    this.currentPage = searchMore.isLoadMore ? this.currentPage + 1 : 0;
    const requestParams: FormularyRequest = {
      groupNumber: this.groupNumber,
      benefitOptionCode: this.benefitOptionCode,
      eligibilitySystemCode: this.eligibilitySystemCode,
      classId: this.classId,
      therapeuticClassCode: searchMore.query,
      expand: 'details',
      offset: this.currentPage * 50,
      limit: 50,
    };
    this._formularyFacade.loadFormularyDrugList(
      requestParams,
      false,
      searchMore.isLoadMore,
    );
  }
}
